import './ScrollProgress.css';

const ScrollProgress = () => (
  <div className="scroll-progress" aria-hidden="true"></div>
);

export default ScrollProgress;
